export const ClientLoggingModel = {
    message: null,
    pageName: null,
    methodName: null,
    jsonResult: null
}